import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { DatePipe } from '@angular/common';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { UpperCasePipe } from '@angular/common';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';

interface Industry {
  id: any;
  name: any;
}

@Component({
  selector: 'app-competency-dictionary-popup',
  templateUrl: './competency-dictionary-popup.component.html',
  styleUrls: ['./competency-dictionary-popup.component.scss'],
})
export class CompetencyDictionaryPopupComponent  implements OnInit {
  competencies: any[] = [];
  buttonColorName: any;
  
  // editKPIInformationForm: FormGroup = new FormGroup({});
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  getMonthsByFiscalandReviewCycle: any = [];
  loggedInUserId: any;
  operation: any;
  kpiId: any = null;
  goalApprovalStatus: boolean = false;
  fileName: any = null;
  fileType: any = null;
  selectedTab: any;
  dropdownSettings: IDropdownSettings = {};
  selectedUserID: any;
  fromYear: any;
  toYear: any;
  loggedInCompanyReviewCycle: any;
  getMonthsForMilestoneFrom: any = [];
  getMonthsForMilestoneTo: any = [];
  invalidReviewCycleWeightage:boolean = false;
  selectedYearReviewCycle:any;
  SubIndustries: any[] = [];
  industryList: any[] = [];
  selectedIndustries: string[] = [];
  selectedSubIndustries: any[] = [];
  searchString = null
  Industries: any[] = []; 
  dropdownList: any[] = [];



  constructor(private httpService: HttpService, private config: Config,
  public dialogRef: MatDialogRef<CompetencyDictionaryPopupComponent>, private fb: FormBuilder, public sharedService: SharedService,
  private encryptionService: EncryptionService, private datePipe: DatePipe, private loader: LoaderService,
  public dialog: MatDialog, private upperCasePipe: UpperCasePipe) { }

  ngOnInit() {
    this.getDropdownIndustry();
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;

    if (this.operation == 'CompetencyDictionary') {
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id', // Not needed if using a simple string array
      textField: 'itemName', // Not needed if using a simple string array
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    
    
    
  
  }



  // getAllSubIndustriesByIndustryID(id: any) {
  //   this.httpService.callGetService(this.config.getAllSubIndustriesByIndustryID + id,).subscribe((data: any) => {
  //     this.subIndustriesList = [];
  //     data?.data?.list.forEach((ele: any) => {
  //       let obj = {
  //         id: ele.id,
  //         name: ele.subIndustryName,
  //       }
  //       this.subIndustriesList.push(obj);
  //     });
  //   })
  // }
  
  getDropdownIndustry() {
    this.loader.simpleLoaderWithDuration(); 
    this.httpService.callGetService(this.config.getIndustryOfDictionary)
      .subscribe((response: any) => { 
        this.loader.dismissLoader();
        
        if (response.status) {
          this.Industries = response.data;
        } else {
          console.error('Failed to fetch industries:', response.message);
        }
      }, error => {
        this.loader.dismissLoader();
        console.error('Error fetching industries:', error);
      });
  }
  

  onItemSelect(item: any) {
    if (item.item_text && !this.selectedIndustries.includes(item.item_text)) {
      this.selectedIndustries.push(item.item_text);
    }
    this.getDropdownSubIndustry();
    
  }
  
  onItemDeselect(item: any) {
    this.selectedIndustries = this.selectedIndustries.filter(
      industry => industry !== item.item_text
    );
    this.getDropdownSubIndustry();
  }
  
  onSelectAll(items: any) {
    console.log('Select All triggered with items:', items);
    this.selectedIndustries = items.map((item: any) => item);
    this.getDropdownSubIndustry();
  }
  
  onDeselectAll() {
    this.SubIndustries = [];
    this.selectedSubIndustries = []

  }

  getDropdownSubIndustry() {
    this.SubIndustries = []
    this.loader.simpleLoaderWithDuration();
    console.log('Selected Industries:', this.selectedIndustries); // Debugging line
    const payload = {
      industries: this.selectedIndustries.filter(item => item !== null && item !== undefined) // Filter out null and undefined
    };
    this.httpService.callPostService(this.config.getSubIndustry, payload) // Replace with your actual API URL
      .subscribe((response: any) => {
        this.loader.dismissLoader();
        console.log('API Response:', response); 

        if (response.status) {
          // Transform the fetched data into a string array
          this.SubIndustries = response.data; // Directly use response.data if it's already a string array
          console.log('Fetched Sub-Industries:', this.SubIndustries); // Debugging line
        } else {
          console.error('Failed to fetch sub-industries:', response.message);
        }
      }, error => {
        this.loader.dismissLoader();
        console.error('Error fetching sub-industries:', error);
      });
  }
  
  
  
  

  onSubIndustrySelect(item: any) {
    console.log('Sub-Industry Selected:', item);
  }

  onSubIndustryDeselect(item: any) {
    console.log('Sub-Industry Deselected:', item);
  }

  onSubIndustrySelectAll(items: any) {
    console.log('All Sub-Industries Selected:', items);
  }

  onSubIndustryDeselectAll() {
    console.log('All Sub-Industries Deselected');
    
  }
  onCompetencySearch(data: any) {
    var search = ''
    this.searchString = data;
    if (data == '') {
      this.searchString = null;
      this.submitIndustries();
      return;
    }
    if (data.length > 1) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.submitIndustries();
          },
            500);
        }
      },
        1500);
    }
  }
  submitIndustries() {
    const payload = {
      searchString: this.searchString,
      industries: this.Industries,
      subIndustries: this.selectedSubIndustries 
    };
  
    this.httpService.callPostService(this.config.getIndustryTable, payload)
      .subscribe(
        (response: any) => {
          console.log('Response:', response);
          if (response.status) {
            this.competencies = response.data; // Set the competencies data
            console.log('Fetched Competencies:', this.competencies);
          } else {
            console.error('Failed to fetch competencies:', response.message);
          }
        },
        error => {
          console.error('Error:', error);
        }
      );
  }
  
  downloadDictionary() {
    const payload = {
      searchString: this.searchString,
      industries: this.Industries,
      subIndustries: this.selectedSubIndustries
    };
  
    this.httpService.callPostService(this.config.dictionaryDownloadCompetency, payload).subscribe(
      (response: any) => {
        const fileUrl = response?.data;
        if (fileUrl) {
          
          // saveAs(environment.downloadURL+response?.data,response?.data);
          const fileName = fileUrl.split(environment.downloadURL)[1];
          saveAs(fileUrl, fileName);
        } else {
          console.error('No file URL received in the response.');
        }
      },
      (error) => {
        console.error('Error downloading the dictionary:', error);
      }
    );
  }
  

  
  
}